import React from 'react'
import { useSelector } from 'react-redux';
import storePersist from '../../../../../redux/storePersist';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function GatewayBasicInfoComponent ({dbas,handleFormChange,selectedGateway,handleInnerFormChange,domainDetails,networks}: any) {
      const countries =  storePersist.get('countries').current?.items;
      const libraryData = useSelector(selectListItems)
  const Cities = [
    {Id: 1, "Name": "Bangalore", "value": "std:080", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 2, "Name": "Chennai", "value": "std:044", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 3, "Name": "Coimbatore", "value": "std:0422", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 4, "Name": "Madurai", "value": "std:0452", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 5, "Name": "Salem", "value": "std:0427", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 6, "Name": "Tirupur", "value": "std:0421", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 7, "Name": "Erode", "value": "std:0424", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 8, "Name": "Trichy", "value": "std:0431", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 9, "Name": "Virudhunagar", "value": "std:04562", "state":"Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
    {Id: 10, "Name": "Trichur", "value": "std:0487", "state":"Kerala", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
  ]
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
          isDisabled
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedGateway?.Name}
          />
           <InputContainer
              isDisabled
              label="UniqueId"
              name="UniqueId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UniqueId',

                )
              }}
              type="text"
              value={selectedGateway?.UniqueId}
          />
           <InputContainer
           isDisabled
                                label="DBA Name"
                                labelField="Name"
                                list={dbas}
                                onValueChange={(event: any, newValue: any) => {
                                  handleInnerFormChange(
                                        event.target.value,
                                        'DBAId',
                                    );
                                }}
                                optionName='Choose DBA'
                                type="select"
                                value={selectedGateway?.DBAId}
                                valueField="Id"
                            />
           <InputContainer
              isDisabled
              label="Subscriber Id"
              name="SubscriberId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SubscriberId',

                )
              }}
              type="text"
              value={selectedGateway?.SubscriberId}
          />
           <InputContainer
              isDisabled
              label="Subscriber Url"
              name="SubscriberUrl"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SubscriberUrl',

                )
              }}
              type="text"
              value={selectedGateway?.SubscriberUrl}
          />
            <InputContainer
               isDisabled
              label="Status"
              name="Status"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Status',

                )
              }}
              type="text"
              value={selectedGateway?.Status}
          />
          <InputContainer
            isDisabled
              label="Type"
              labelField="Type"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Type'
                )
              }}
              type="text"
              value={selectedGateway?.Type}

            />
          <InputContainer
             isDisabled
            label="Domain Name" 
                             labelField="Name"
                             list={domainDetails}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleFormChange(
                                valueData,
                               'Domains'
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedGateway?.Domains}
         />
        <InputContainer
           isDisabled
            label="Network Name" 
                             labelField="Name"
                             list={networks}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleInnerFormChange(
                                valueData,
                                'Networks',
                              )
                             }}
                             type="multiselect"
                             valueField="Id"
                             value={selectedGateway?.Networks}
         />
         <InputContainer
            isDisabled
                                label="Country Name"
                                labelField="Name"
                                list={countries}
                                onValueChange={(event: any, newValue: any) => {
                                  handleInnerFormChange(
                                        event.target.value,
                                        'country',
                                    );
                                }}
                                optionName='Choose Country'
                                type="select"
                                value={selectedGateway?.country}
                                valueField="Name"
                            />

<InputContainer
   isDisabled
            label="Cities" 
                             labelField="Name"
                             list={Cities}
                             onValueChange={( newValue: any) => {
                               const valueData: any = newValue.map((option: any) => option?.value)
                               handleInnerFormChange(
                                valueData,
                                'Cities',
                              )
                             }}
                             type="multiselect"
                             valueField="Name"
                             value={selectedGateway?.Cities}
         />
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}